import { useEffect } from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { ArrowLeft, Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";
import { blogPosts } from "@/data/blogData";
import { Link } from "react-router-dom";

const Blog = () => {
  const { t, language } = useLanguage();

  useEffect(() => {
    document.title = "Blog | Inbloqs";
    window.scrollTo(0, 0);
  }, []);

  const currentPosts = blogPosts[language];

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow pt-28 pb-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-12 text-center">
            <h1 className="section-heading mb-4">{t("blog_title")}</h1>
            <p className="section-subtitle max-w-3xl mx-auto">
              {t("blog_subtitle")}
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {currentPosts.map((post) => (
              <div key={post.slug} className="soft-card overflow-hidden">
                <div className={`h-48 ${post.imageColor} flex items-center justify-center`}>
                  <div className="w-16 h-16 rounded-full bg-white/20 dark:bg-black/20"></div>
                </div>
                <div className="p-6">
                  <div className="flex justify-between items-center mb-3">
                    <span className="px-3 py-1 rounded-full bg-blue-100/80 dark:bg-blue-950/40 text-blue-700 dark:text-blue-300 text-xs font-medium">
                      {post.category}
                    </span>
                    <div className="flex items-center text-slate-500 dark:text-slate-400 text-sm">
                      <Calendar className="w-4 h-4 mr-1" />
                      {post.date}
                    </div>
                  </div>
                  <h3 className="text-lg font-semibold mb-2 text-slate-900 dark:text-white">{post.title}</h3>
                  <p className="text-slate-600 dark:text-slate-400 text-sm mb-4 line-clamp-3">{post.excerpt}</p>
                  <Link to={`/blog/${post.slug}`} className="text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 transition-colors text-sm font-medium">
                    {t("read_more")} →
                  </Link>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <Button asChild variant="outline" size="lg" className="mx-auto rounded-full border border-slate-200 bg-white/80 text-slate-800 hover:bg-slate-50 dark:border-slate-800 dark:bg-slate-900/70 dark:text-slate-200 dark:hover:bg-slate-900">
              <Link to="/">
                <ArrowLeft className="mr-2 w-4 h-4" />
                {language === "en" ? "Back to Home" : "Volver al Inicio"}
              </Link>
            </Button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Blog;
